import { useEffect } from 'react';
import environment from '@/environment';

export const useSalesforceChat = ({ firstName, lastName, email, enabled }) => {
  const {
    SALESFORCE_BASE_DOMAIN: baseDomain,
    SALESFORCE_HELP_BASE_DOMAIN: helpDomain,
    SALESFORCE_CHAT_EMBEDDED_ID: embeddedId,
    SALESFORCE_CHAT_TEMPLATE: template,
    SALESFORCE_CHAT_CONTENT_URL: contentUrl,
    SALESFORCE_CHAT_DEPLOYMENT_ID: deploymentId,
    SALESFORCE_CHAT_BUTTON_ID: buttonId,
    SALESFORCE_CHAT_BASE_URL: baseUrl,
    SALESFORCE_GSLB_BASE_URL: gslbBaseUrl,
  } = environment;
  const vars = {
    baseDomain,
    helpDomain,
    embeddedId,
    template,
    contentUrl,
    deploymentId,
    buttonId,
    baseUrl,
    gslbBaseUrl,
  };

  const hasUndefined = Object.entries(vars).some(([key, value]) => {
    if (typeof value === 'undefined') {
      console.warn(`Salesforce Warning: ${key} is undefined`);
      return true;
    }
    return false;
  });

  useEffect(() => {
    if (!enabled) return; // bail early if feature disabled
    if (hasUndefined) return;
    const initESW = gslb => {
      window.embedded_svc.settings.displayHelpButton = true;
      window.embedded_svc.settings.language = '';
      window.embedded_svc.settings.defaultMinimizedText = 'Chat with EVERFI Support';

      window.embedded_svc.settings.prepopulatedPrechatFields = {
        FirstName: firstName,
        LastName: lastName,
        Email: email,
      };

      window.embedded_svc.settings.enabledFeatures = ['LiveAgent'];
      window.embedded_svc.settings.entryFeature = 'LiveAgent';

      window.embedded_svc.init(baseDomain, helpDomain, gslb, embeddedId, template, {
        baseLiveAgentContentURL: contentUrl,
        deploymentId,
        buttonId,
        baseLiveAgentURL: baseUrl,
        eswLiveAgentDevName: 'Admin_Support',
        isOfflineSupportEnabled: true,
      });
    };

    if (window.embedded_svc) {
      // Already loaded
      initESW(gslbBaseUrl);
    } else {
      if (!document.getElementById('embedded-js-client')) {
        const script = document.createElement('script');
        script.src = 'https://service.force.com/embeddedservice/5.0/esw.min.js';
        script.id = 'embedded-js-client';
        script.onload = () => initESW(null);
        document.head.appendChild(script);
      }
    }

    return () => {
      if (window.embedded_svc) {
        const existingScript = document.getElementById('embedded-js-client');
        document.head.removeChild(existingScript);
      }
    };
  }, [
    baseDomain,
    helpDomain,
    embeddedId,
    template,
    contentUrl,
    deploymentId,
    buttonId,
    baseUrl,
    gslbBaseUrl,
    firstName,
    lastName,
    email,
  ]);
};
